import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rtw-overlay" }
const _hoisted_2 = { class: "rtw-popup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RightToWorkCheck = _resolveComponent("RightToWorkCheck")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "rtw-close-popup",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        "aria-label": "Close"
      }, "×"),
      _createVNode(_component_RightToWorkCheck, {
        baseUrl: _ctx.baseUrl,
        officerId: _ctx.officerId,
        officerName: _ctx.officerName,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
        onSaved: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('saved')))
      }, null, 8, ["baseUrl", "officerId", "officerName"])
    ])
  ]))
}